/**
 * SA per-demo reset mutation hook (B-11).
 *
 * Endpoint: POST /admin/demo/{slug}/reset
 */
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";
import { queryClient } from "@/lib/queryClient";

interface DemoSlugResetBody {
  admin_email: string;
  admin_first_name: string;
  admin_last_name: string;
  /** Must equal `"RESET DEMO {slug}"` */
  confirm: string;
}

interface DemoSlugResetResponse {
  tenant_id: string;
  slug: string;
  admin_email: string;
  jds_seeded: number;
  candidates_seeded: number;
  rankings_seeded: number;
  initial_credits: number;
  audit_event_id: string;
  login_url: string;
}

export function useResetDemo(slug: string) {
  return useMutation<DemoSlugResetResponse, ApiError, DemoSlugResetBody>({
    mutationFn: async (body) => {
      const r = await apiClient.post<DemoSlugResetResponse>(
        `/admin/demo/${slug}/reset`,
        body,
      );
      return r.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "demos"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "demo", slug, "status"] });
    },
  });
}
